import React from 'react';
import './Footer.css';
import telegramIcon from '../assets/telegram.svg';
import twitterIcon from '../assets/twitter.svg';
import discordIcon from '../assets/discord.svg';
import logoFooter from '../assets/Logofooter.webp';
import footerBg from '../assets/footerbackground.png';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer
    className="footer"
    style={{
      backgroundImage: `url(${footerBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <div className="footer-logo">
      <img src={logoFooter} alt="VORTREX Logo" />
      <h2>VORTREX</h2>
    </div>

    <div className="footer-links">
      <Link to="/about">About Us</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
      <Link to="/terms-of-use">Terms</Link>
    </div>

    <div className="footer-socials">
      <a href="#" target="_blank" rel="noopener noreferrer">
        <img src={telegramIcon} alt="Telegram" />
      </a>
      <a href="#" target="_blank" rel="noopener noreferrer">
        <img src={twitterIcon} alt="Twitter" />
      </a>
      <a href="#" target="_blank" rel="noopener noreferrer">
        <img src={discordIcon} alt="Discord" />
      </a>
    </div>

    <div className="footer-disclaimer">
      <small>
        <strong>Disclaimer:</strong> VORTREX is a fully autonomous AI trading bot platform. It does not guarantee profits or financial outcomes. All trading involves risk and users should exercise caution. This is not financial advice — always DYOR (Do Your Own Research) before using any automated trading systems.
        <br /><br />
        VORTREX is a non-custodial system — it does not access your wallet, funds, or personal data. You retain full control at all times.
        <br /><br />
        VORTREX is not affiliated with Facebook, Meta, or any external entities mentioned.
      </small>
    </div>

    <div className="footer-copy">© 2025 VORTREX. All rights reserved.</div>
  </footer>
);

export default Footer;
